import React, { Fragment } from "react";
import Banner from "./Banner";
import "swiper/css";
import AboutHome from "./AboutHome";
import ApplyFor from "./ApplyFor";
import PopularOnline from "./PopularOnline";
import NewFact from "./NewFact";
import Events from "./Events";
import LatestNews from "./LatestNews";
// import News from "./Dream";
// import Clients from "./Clients";
// import Material from "./Material";
// import Contact from "../contact/Contact";
// import About from "../about/About";

const Home = () => {
  return (
    <Fragment>
      <Banner />
      <PopularOnline />
      <AboutHome />
      <ApplyFor />
      <NewFact />
      <Events />
      <LatestNews />
    </Fragment>
  );
};

export default Home;
